<template>
  <woot-modal :show.sync="isVisible" :on-close="onClose">
    <div class="h-auto overflow-auto flex flex-col mb-30 pb-6">
      <woot-modal-header header-title="Audits" />
      <spinner v-if="uiFlags.isFetchingAudit" class="mt-4" />
      <div class="px-8" v-else-if="audits.length > 0">
        <table class="min-w-full border border-gray-300">
          <tbody>
            <tr>
              <td style="padding-left: 0; padding-right: 0">
                {{ $t('COMPLAINT.AUDIT.DESCRIPTION') }}
              </td>
              <td style="padding-left: 0; padding-right: 0">
                {{ $t('COMPLAINT.AUDIT.TIME') }}
              </td>
            </tr>
            <tr v-for="(v, i) in audits" :key="i">
              <td style="padding-left: 0; padding-right: 0">
                {{ v.description }}
              </td>
              <td style="padding-left: 0; padding-right: 0">
                {{ v.time }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <span class="px-8" v-else>No Data</span>
    </div>
  </woot-modal>
</template>

<script>
import Spinner from 'shared/components/Spinner.vue';
import { mapGetters } from 'vuex';
export default {
  components: {
    Spinner,
  },
  props: {
    isVisible: {
      default: true,
    },
  },
  computed: {
    ...mapGetters({
      auditsRaw: 'complaints/getViewableAudits',
      uiFlags: 'complaints/getUiFlags',
    }),
    audits() {
      return this.auditsRaw.map(audit => {
        let description = '';

        if (audit.audited_changes.hasOwnProperty('status_id')) {
          description = this.$t('COMPLAINT.AUDIT.STATUS_CHANGE', {
            from: this.auditStatus(audit.audited_changes.status_id[0]),
            to: this.auditStatus(audit.audited_changes.status_id[1]),
            agent: audit.agent_name,
          });
        }

        if (audit.audited_changes.hasOwnProperty('pending_status')) {
          description = this.$t('COMPLAINT.AUDIT.PENDING_STATUS_CHANGE', {
            from: this.pendingStatusText(
              audit.audited_changes.pending_status[0] || ''
            ),
            to: this.pendingStatusText(
              audit.audited_changes.pending_status[1] || ''
            ),
            agent: audit.agent_name,
          });
        }

        return {
          description,
          time: this.formatTime(audit.time),
        };
      });
    },
  },
  methods: {
    onClose() {
      this.$emit('on-close');
    },
    auditStatus(statusId) {
      const statusMap = {
        4: this.$t('COMPLAINT.AUDIT.STATUS.PENDING'),
        5: this.$t('COMPLAINT.AUDIT.STATUS.DONE'),
        6: this.$t('COMPLAINT.AUDIT.STATUS.CANCEL'),
      };
      return statusMap[statusId] || this.$t('COMPLAINT.AUDIT.STATUS.UNKNOWN');
    },
    pendingStatusText(status) {
      const pendingStatusMap = {
        'Menunggu Hasil Teknisi': this.$t('COMPLAINT.AUDIT.STATUS.TECHNICAL'),
        'Menunggu Hasil NOC': this.$t('COMPLAINT.AUDIT.STATUS.NOC'),
        'Menunggu Konfirmasi Pelanggan': this.$t(
          'COMPLAINT.AUDIT.STATUS.CUSTOMER'
        ),
      };
      return pendingStatusMap[status] || status;
    },
    formatTime(timeString) {
      const match = timeString.match(
        /(\d+)\s*jam|\s*(\d+)\s*menit|\s*(\d+)\s*detik/g
      );

      let hours = 0,
        minutes = 0,
        seconds = 0;

      if (match) {
        match.forEach(part => {
          if (part.includes('jam')) {
            hours = parseInt(part);
          } else if (part.includes('menit')) {
            minutes = parseInt(part);
          } else if (part.includes('detik')) {
            seconds = parseInt(part);
          }
        });
      }

      if (hours && minutes) {
        return this.$t('COMPLAINT.AUDIT.TIME_FORMAT.TIME_HOURS_MINUTES', {
          hours,
          minutes,
        });
      } else if (minutes && seconds) {
        return this.$t('COMPLAINT.AUDIT.TIME_FORMAT.TIME_MINUTES_SECONDS', {
          minutes,
          seconds,
        });
      } else if (hours) {
        return this.$t('COMPLAINT.AUDIT.TIME_FORMAT.TIME_HOURS', { hours });
      } else if (minutes) {
        return this.$t('COMPLAINT.AUDIT.TIME_FORMAT.TIME_MINUTES', { minutes });
      } else if (seconds) {
        return this.$t('COMPLAINT.AUDIT.TIME_FORMAT.TIME_SECONDS', { seconds });
      } else {
        return timeString;
      }
    },
  },
};
</script>

<style></style>
